import { any, bool, shape, string } from "prop-types";

// eslint-disable-next-line react/forbid-prop-types
const AutocompleteOptionType = shape({ id: string, label: string, data: any, isDefault: bool });

export default AutocompleteOptionType;
